"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_1 = require("react");
const Pill_1 = require("./Pill");
const index_1 = require("./index");
const Text_1 = require("./Text");
const MultiSelectInput = ({ options, selected, onSelectedChange, style }) => {
    const ref = react_1.useRef(null);
    const [isOpen, setOpen] = react_1.useState(false);
    const [text, setText] = react_1.useState('');
    react_1.useEffect(() => {
        const closeOnOutsideClick = (e) => {
            if (!ref || !ref.current || !open) {
                return;
            }
            if (!ref.current.contains(e.target)) {
                setOpen(false);
                setText('');
            }
        };
        document.addEventListener('click', closeOnOutsideClick);
        return () => document.removeEventListener('click', closeOnOutsideClick);
    });
    const handleFocus = () => {
        setOpen(true);
    };
    const handleOnChange = (e) => {
        setText(e.target.value);
    };
    const handleKeyPress = (e) => {
        if (e.charCode === 13) {
            if (text !== '' && unselectedOptions.length === 1) {
                handleSelected(unselectedOptions[0]);
            }
            else {
                handleSelected(text);
            }
        }
    };
    const handleSelected = (ele) => {
        if (selected.includes(ele) || ele === '') {
            return;
        }
        onSelectedChange([...selected, ele]);
        setText('');
    };
    const handleUnselected = (ele) => {
        onSelectedChange(selected.filter(s => s !== ele));
    };
    const unselectedOptions = options
        .filter(s => !selected.includes(s))
        .filter(s => {
        if (text === '') {
            return true;
        }
        if (s.toLowerCase().includes(text.toLowerCase())) {
            return true;
        }
    });
    return (React.createElement("div", { ref: ref, style: Object.assign({ position: 'relative' }, style) },
        React.createElement("div", { style: {
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
            } },
            selected.map(ele => {
                return (React.createElement(Pill_1.default, { style: {
                        margin: 2,
                    }, key: ele, value: ele, onRemove: () => handleUnselected(ele) }));
            }),
            React.createElement("style", { type: "text/css" }, `
                        .multiSelectInputText:focus { outline: none; }
                        .multiSelectInputText::-webkit-input-placeholder { font-size: 16px; font-weight: 400; }
                        .multiSelectInputText::-moz-placeholder { font-size: 16px; font-weight: 400; }
                        .multiSelectInputText:-ms-input-placeholder { font-size: 16px; font-weight: 400; }
                    `),
            React.createElement("div", { style: {
                    position: 'relative',
                } },
                React.createElement("input", { className: "multiSelectInputText", type: "text", style: Object.assign({ height: 24, flex: '1 1', border: 'none' }, index_1.text, index_1.light, index_1.medium), onFocus: handleFocus, onChange: handleOnChange, onKeyPress: handleKeyPress, value: text, placeholder: "Add or remove tags" }),
                isOpen && (React.createElement(Dropdown, { options: unselectedOptions, onClickHandler: handleSelected, inputText: text }))))));
};
const Dropdown = ({ options, onClickHandler, inputText }) => {
    if (options.length === 0 && inputText === '') {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { style: {
            position: 'absolute',
            minWidth: '240px',
            background: index_1.white,
            borderWidth: 1,
            borderRadius: 2,
            borderStyle: 'solid',
            borderColor: index_1.titanium,
            marginTop: 8,
        } },
        React.createElement(index_1.SelectableList, { device: 'Desktop' },
            options.map(ele => {
                return (React.createElement("div", { key: ele, style: {
                        height: 32,
                        minWidth: '240px',
                        display: 'flex',
                        alignItems: 'center',
                    }, onClick: () => onClickHandler(ele) },
                    React.createElement(Text_1.default, { key: ele, text: ele, size: "small" })));
            }),
            inputText && (React.createElement("div", { key: 'createTagKey', style: {
                    height: 56,
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                }, onClick: () => onClickHandler(inputText) },
                React.createElement(Text_1.default, { text: `Create tag "${inputText}"`, size: "small" }))))));
};
exports.default = MultiSelectInput;
